"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.error.cause.js");
require("core-js/modules/es.object.to-string.js");
var _bom = require("@api/business/mdg/material/bom");
var _login = require("@api/login");
var _formatterDictMixin = _interopRequireDefault(require("@views/business/mixins/formatterDictMixin"));
var _store = _interopRequireDefault(require("@/store"));
var _default = exports.default = {
  name: 'bomDialog',
  mixins: [_formatterDictMixin.default],
  props: {
    /* 弹窗控制 */
    open: {
      type: Boolean,
      default: false
    },
    /* dialog 标题 */
    title: {
      type: String,
      default: ''
    },
    /* 弹框打开类型 */
    openType: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    var _this = this;
    // 自定义验证
    var checkqty = function checkqty(rule, value, callback) {
      if (!value) {
        return callback(new Error('用量不能为0'));
      } else {
        callback();
      }
    };
    return {
      findById: _bom.findById,
      // 请求接口，组件会调用这个请求方法，在对话框打开的时候默认使用该方法请求表单数据并更新打开的对话框中的表单数据。如果去掉，则不会执行默认请求数据方法。
      show: false,
      // 对话框表单组件的显示状态
      loading: false,
      // 对话框表单的加载状态
      disabled: false,
      // 对话框表单的禁用状态（输入控件禁用）
      tableEntryForm: {
        tableData: []
      },
      id: '',
      /** 对话框表单操作按钮 */
      btns: [
      // 对话框的标准区操作按钮（code 值参考规范文档）
      {
        // 保存按钮
        code: 'save',
        // 按钮开关类型
        loading: false,
        // 按钮加载状态，true的时候按钮会显示一个加载等待图标，并且禁止点击
        disabled: false,
        // 按钮禁用状态
        show: function show() {
          return _this.openType !== 'view';
        },
        permi: ['mdg:bom:add'],
        // 按钮点击触发事件
        click: function click(btn, e) {
          _this.bomSave();
        }
      }],
      /** 栅格控制器（全局控制） */
      grid: {
        span: 12,
        md: {
          span: 8
        },
        xs: {
          span: 24
        }
      },
      /* 使用模版组件的字段 类目 */
      formItems: {
        /* 基础数据 */
        basic: [{
          label: '工作中心编码',
          code: 'assemblyMaterialName',
          type: 'input',
          readonly: true
        }, {
          label: '工作中心名称',
          code: 'assemblyMaterialName',
          type: 'input',
          readonly: true
        }, {
          label: '模型',
          code: 'assemblyMaterialName',
          type: 'input',
          readonly: true
        }],
        remark: [{
          label: '备注',
          code: 'remark',
          grid: 24
        }]
      },
      /** 表单数据对象 */
      form: {
        id: '',
        packageid: '',
        // materialUid         : '',
        materialId: '',
        materialCode: '',
        materialName: '',
        assemblyMaterialUid: '',
        assemblyMaterialId: '',
        assemblyMaterialCode: '',
        assemblyMaterialName: '',
        assemblyMaterialSpecification: '',
        assemblyMaterialUnit: '',
        materialSpecification: '',
        bomVersion: '',
        materialUnit: '',
        qty: '',
        companyId: '',
        companyCode: '',
        companyName: '',
        factoryId: '',
        factoryCode: '',
        factoryName: '',
        useStatus: '10',
        productionVersionId: '',
        productionVersion: '',
        bomRetrospect: '10',
        retrospectType: '',
        bomType: '10',
        isReoil: 'Y',
        remark: ''
      },
      /** 表单校验规则 */
      rules: {
        materialCode: [{
          required: true,
          message: '请输入 物料编码',
          trigger: 'blur'
        }],
        assemblyMaterialCode: [{
          required: true,
          message: '请输入 总成编码',
          trigger: 'blur'
        }],
        qty: [{
          required: true,
          validator: checkqty,
          trigger: 'blur'
        }],
        useStatus: [{
          required: true,
          message: '请输入 状态',
          trigger: 'blur'
        }],
        bomRetrospect: [{
          required: true,
          message: '请输入 是否追溯',
          trigger: 'blur'
        }],
        bomType: [{
          required: true,
          message: '请输入 BOM类型',
          trigger: 'blur'
        }],
        bomVersion: [{
          required: true,
          message: '请输入 BOM版本',
          trigger: 'blur'
        }]
      }
    };
  },
  watch: {
    open: {
      handler: function handler(nv) {
        this.show = nv;
      }
    },
    show: {
      handler: function handler(nv) {
        this.$emit('update:open', nv);
      }
    }
  },
  methods: {
    // 保存
    bomSave: function bomSave() {
      var _this2 = this;
      this.$$formValidate(['wl-dialog-form'], function () {
        var request = _this2.form.id ? _bom.update : _bom.add;
        // 让对话框、表格进入等待状态（禁用不可点击）
        _this2.loading = true;
        _this2.disabled = true;
        request(_this2.form).then(function (res) {
          if (res.code === 200) {
            var _this2$$parent$$refs$;
            _this2.msgSuccess(_this2.form.id ? '修改成功' : '新增成功');
            // Object.assign(this.form, res.data)
            _this2.show = false;
            (_this2$$parent$$refs$ = _this2.$parent.$refs.bomList) === null || _this2$$parent$$refs$ === void 0 || _this2$$parent$$refs$.refresh();
          }
        }).finally(function () {
          setTimeout(function () {
            // 让对话框、表格解除等待状态（禁用恢复点击）
            _this2.loading = false;
            _this2.disabled = false;
          }, 500);
        });
      });
    },
    // 提交
    bomSubmit: function bomSubmit() {
      var _this3 = this;
      console.log(this.form);
      // 先校验必填，再提交
      this.$$formValidate(['wl-dialog-form'], function () {
        // 让对话框、表格进入等待状态（禁用不可点击）
        _this3.loading = true;
        _this3.disabled = true;
        (0, _bom.submit)(_this3.form).then(function (response) {
          if (response.code === 200) {
            _this3.msgSuccess('提交成功');
            setTimeout(function () {
              var _this3$$parent$$refs$;
              _this3.show = false;
              (_this3$$parent$$refs$ = _this3.$parent.$refs.bomList) === null || _this3$$parent$$refs$ === void 0 || _this3$$parent$$refs$.refresh();
            }, 500);
          }
        }).finally(function () {
          setTimeout(function () {
            // 让对话框、表格解除等待状态（禁用恢复点击）
            _this3.loading = false;
            _this3.disabled = false;
          }, 500);
        });
      });
    },
    /* ok dialog dialog对话框右下角确定按钮触发事件 */onOk: function onOk() {
      this.bomSave();
    },
    /* open dialog 详情页对话框打开前触发 */openDialog: function openDialog() {
      var _this4 = this;
      if (this.openType === 'add') {
        (0, _login.getInfo)().then(function (res) {
          if (res.user) {
            _this4.form.factoryId = res.user.dept.deptId;
            _this4.form.factoryCode = res.user.dept.deptCode;
            _this4.form.factoryName = res.user.dept.deptName;
            _this4.form.companyId = res.user.rootDept.deptId;
            _this4.form.companyCode = res.user.rootDept.deptCode;
            _this4.form.companyName = res.user.rootDept.deptName;
          }
        });
      }
    },
    /* close dialog 详情页对话框关闭后触发 */closeDialog: function closeDialog() {
      this.resetForm('form');
    },
    /* get datas success 对话框请求详细数据 成功 回调函数 */getDatasSuccess: function getDatasSuccess(res) {},
    /* get datas error 对话框请求详细数据 失败 回调函数 */getDatasError: function getDatasError(res) {}
  },
  created: function created() {
    this.show = this.open;
  }
};